export const projectCatalog = [
    {
        "title": "智能问数 Agent：业务自助分析与 Lattice 数仓协同",
        "period": "2026.08-至今",
        "keywords": "【关键词】业务语义、数据治理、智能分析、流程自动化、平台建设、成本优化",
        "desc": "面向业务高频取数与经营分析需求，主导智能问数平台建设，将分散的数据口径、分析经验与数据服务组织为可复用、可核验的自助分析能力，改善通用问数工具在业务适配、响应效率和使用成本方面的不足。",
        "points": [
            "架构与产品策略：建立业务语义、分析编排和数据服务之间的清晰分工，按场景复杂度组织智能推理与流程自动化；兼顾分析质量、响应效率与运行成本，使高频需求能够稳定复用，复杂问题具备澄清、追问和持续扩展能力。",
            "数据质量与验收：沉淀业务标准问题与统一指标口径，10 个模板题端到端验收通过，高频标准题口径正确率不低于 90%；验收范围内越权结果与不合规查询提交均为 0。建立结果追溯、历史回看和反馈复核机制，使业务能够自助获取并核验分析结果。",
            "数仓协同与业务应用：打通 Lattice 实时指标、分层数据加工与分析服务，完成高频数据聚合和复用，支撑支付异常追查、获客漏斗分析与日常经营取数；统一数据供给与分析口径，减少重复加工及业务、数据团队之间的反复沟通。",
            "资源统筹与降本成果：结合业务需求、既有能力和平台投入，推动自建与采购取舍及共用服务整合；相关数据能力建设与成本优化已实现每年节省至少 86 万元，数数平台当前总成本为 180 万元/年。",
            "产品化交付：交付自助分析与主动预警两类服务，覆盖多项目使用、分析结果留存、消息触达和反馈处理，将按需取数与异常通知融入日常业务流程，形成能够持续扩展的企业数据应用平台。"
        ],
        "id": "query",
        "legacyIndex": 0,
        "category": "数据与经营",
        "stage": "已交付",
        "metric": "10 个模板题端到端验收通过；高频标准题口径正确率 ≥90%；相关数据能力建设与成本优化每年节省至少 86 万元。",
        "labels": [],
        "architectureKey": "query",
        "evidence": {
            "items": [
                [
                    "10 个",
                    "模板题验收",
                    "端到端通过"
                ],
                [
                    "≥90%",
                    "标准题口径正确率",
                    "高频标准题验收范围"
                ],
                [
                    "至少 86 万元",
                    "每年节省成本",
                    "相关数据能力建设与成本优化"
                ]
            ],
            "sources": [
                1,
                1,
                3
            ],
            "emphasis": [
                "10 个模板题端到端验收通过",
                "高频标准题口径正确率不低于 90%",
                "每年节省至少 86 万元",
                "验收范围内越权结果与不合规查询提交均为 0"
            ],
            "qualitative": false
        }
    },
    {
        "title": "Game Factory：自然语言驱动的游戏生成 Agent",
        "period": "2026.07-2026.09",
        "keywords": "【关键词】生成式 AI、游戏生成、多模态、数值控制、公平性验证、质量治理、运行安全",
        "desc": "主导基于 Rust / 内嵌 Harness 的自然语言游戏生成系统架构与交付标准，将玩法创意、视觉设计、素材制作和交互实现连接为完整生产流程，将开放式需求转化为可运行、可验证、可交付的游戏产物，支持创意验证与产品迭代。",
        "points": [
            "生成架构与可靠执行：建立面向复杂生成任务的执行体系，统一任务推进、状态管理和异常恢复；协调多阶段生成之间的依赖与质量要求，控制重复执行和失败重试带来的成本，提升长流程生成的稳定性与可追溯性。",
            "数值控制：实现覆盖规则定义、内容生成和游戏运行的多阶段数值校验，将概率、返还、策略及金额边界纳入统一质量控制；持续核对规则与实现的一致性，拦截非法参数、越界结果及版本不一致问题。",
            "公平性验证：落地规则透明、随机结果可验证及过程可追溯的公平性机制，支持关键结果独立复核；针对信息泄漏、重复抽取和规则歧义开展检查，将公平性要求贯穿设计、验证与交付。",
            "多模态内容生成：协同玩法、视觉、素材和交互生成，保持内容风格与规则约束一致；完成角色、场景及界面表现的自动生成和组装，形成可直接运行的 H5 游戏，支撑从创意到可玩产品的完整交付。",
            "运行安全：建立核心规则执行与生成内容之间的隔离，控制生成内容的数据访问、外部通信和结果决策权限；实现运行状态恢复与重复操作控制，保障游戏过程的一致性和可核验性。",
            "部署与质量治理：落地覆盖定义审核、实现验证和部署准入的分阶段质量体系，将数值、公平性、安全及产物一致性作为交付标准；建立版本、验证结果与交付制品的对应关系，形成变更复验、风险处置和交付追溯机制。",
            "交付与验证成果：完成从自然语言需求到游戏生成、运行和交付的完整流程，覆盖真实模型生成、移动端交互及异常恢复验证；形成可复用的生成能力、质量标准与游戏交付资产，支撑后续玩法扩展。"
        ],
        "id": "gamefactory",
        "legacyIndex": 1,
        "category": "游戏与创作",
        "stage": "已交付",
        "metric": "完成自然语言需求到游戏生成、运行和交付的完整流程；覆盖真实模型生成、移动端交互与异常恢复验证。",
        "labels": [],
        "architectureKey": "gamefactory",
        "evidence": {
            "items": [
                [
                    "完整流程",
                    "自然语言到可玩游戏",
                    "生成 · 运行 · 交付"
                ],
                [
                    "分阶段",
                    "质量与准入控制",
                    "数值 · 公平性 · 安全"
                ],
                [
                    "可恢复",
                    "可靠任务与游戏运行",
                    "状态恢复 · 重复操作控制"
                ]
            ],
            "sources": [
                6,
                5,
                4
            ],
            "emphasis": [],
            "qualitative": true
        }
    },
    {
        "title": "企业知识库：企业级知识服务与智能调查",
        "period": "2026.06-至今",
        "keywords": "【关键词】企业知识平台、RAG、业务语义、智能检索、Agentic 调查、权限治理、质量评测",
        "desc": "主导面向全员知识使用与团队协作的企业知识平台建设，提供资料管理、知识查询、证据问答和跨资料调查；将分散信息转化为可持续维护的企业知识服务，支撑“敞亮人”新人赋能及产研 Agent 的知识调用。",
        "points": [
            "知识资产与平台架构：打通知识接入、加工、检索和应用流程，统一资料版本、来源和更新管理；保留复杂文档的语义与结构，支持知识随业务变化持续更新，减少重复整理并提升知识复用效率。",
            "业务语义与关系分析：构建企业术语、业务对象和关系模型，统一跨资料的理解口径，处理同名对象、历史变化和关联信息；使知识查询能够结合业务关系形成完整解释，并回溯结论依据。",
            "智能检索与证据组织：融合多种检索能力，按任务需要筛选、关联和组织有效证据；兼顾事实覆盖、关键前提与结论完整性，减少重复材料和无关信息对回答质量的影响。",
            "Agentic 调查：实现围绕复杂问题的多轮检索、资料核对、关系追踪与分析计算，依据证据充分性推进调查；支持发现缺口、纠正查询和交叉验证，输出有依据、可追溯的分析结论。",
            "权限与可靠运行：建立贯穿资料、检索和知识应用的权限管理，支持授权变化后的访问控制与内容更新；完善异步处理、故障恢复和运行观测，保障多业务线协同使用中的数据安全与服务连续性。",
            "评测与持续治理：建立覆盖知识质量、检索有效性、回答准确性和运行可靠性的分层评测体系，结合业务标准问题、专项验证与回归持续改进；将知识冲突、内容缺口和失效信息纳入日常治理，支撑平台长期维护。",
            "集团落地与质量成果：已接入集团内部全部业务线使用，支撑业务知识查询、规范检索与新人赋能；评测集覆盖 452 道题，答案正确性达 0.825。"
        ],
        "id": "knowledge",
        "legacyIndex": 2,
        "category": "知识与组织",
        "stage": "已交付",
        "metric": "已接入集团内部全部业务线；评测集覆盖 452 道题，答案正确性达 0.825。",
        "labels": [],
        "architectureKey": "knowledge",
        "evidence": {
            "items": [
                [
                    "全部业务线",
                    "集团内部接入使用",
                    "知识查询 · 规范 · 新人赋能"
                ],
                [
                    "452 道",
                    "评测集题目",
                    "现有评测规模"
                ],
                [
                    "0.825",
                    "答案正确性",
                    "评测集结果"
                ]
            ],
            "sources": [
                6,
                6,
                6
            ],
            "emphasis": [
                "已接入集团内部全部业务线使用",
                "评测集覆盖 452 道题，答案正确性达 0.825"
            ],
            "qualitative": false
        }
    },
    {
        "title": "Talent Mining：人才评估与面试辅助 Agent",
        "period": "2026.06-至今",
        "keywords": "【关键词】岗位胜任力、行为事件访谈、结构化面试、职业心理、测评设计、证据引用、人机协同",
        "desc": "面向 HR 与业务面试官，主导招聘评估产品定义与核心能力建设，将分散的简历阅读、岗位判断和面试准备整合为候选人档案、评估、追问、横向对比和面试后结论的连续工作流程，推动真实招聘场景验证与团队协作交付。",
        "points": [
            "岗位胜任力与行业建模：融合 JD、岗位行业经验与用人标准，形成 Agent 研发、AI 基建和 AI 数据等岗位的可配置模板，明确能力要求与可观察行为；支持行业经验补充输入，生成岗位相关的价值点、风险线索与待验证事项，通过原文引用支持判断复核。",
            "行为证据与结构化面试：将 BEI 行为事件访谈、STAR 原则和 Topgrading 职业经历核查思路用于前期评估与面试题生成；围绕具体事件梳理背景、个人职责、行动和结果，并跨经历比较能力表现与贡献边界，形成连续追问与验证依据。",
            "职业心理与行为评估设计：借鉴霍根测评关注的工作风格、动机与价值观、行为风险维度，围绕岗位协作、压力情境和职业选择组织初筛线索与情境追问；将优势和风险转化为待验证问题，以具体事件和可观察行为支撑岗位匹配判断。",
            "测评标准与质量校准：以岗位胜任要求建立共同评价维度与行为分级标准，区分简历自述、面试表现、现场观察和独立核验；制定信息遗漏、引用支持度、评分一致性及人工复核耗时等验收口径，将材料不足保留为待验证项，支持面试官校准判断。",
            "面试辅助与结果沉淀：实现面试准备包、连续追问、多人对比及结论整理，区分简历陈述、面试表现和最终判断；结合具体经历设计验证问题，保留面试官审核与决策，形成可复用的岗位模板和招聘材料。",
            "产品交付与业务协作：完成本地客户端产品与真实候选人链路验证，协同团队推进在线版本、使用指引和跨部门试用；明确按使用人授权与数据隔离要求，推动产品演示、现场引导和业务反馈进入迭代流程。",
            "阶段成果：已完成简历结构化解析、岗位评估及面试追问链路验证，并形成招聘实际使用材料；与 HR、技术面试官共同识别多轮面试协同及既有招聘系统接入需求，确定后续产品演进范围。"
        ],
        "id": "talent",
        "legacyIndex": null,
        "category": "知识与组织",
        "stage": "业务试用",
        "metric": "将岗位胜任力、行为访谈与职业心理维度用于前期评估和面试题生成；完成真实候选人链路验证，推进在线协作与跨部门试用。",
        "labels": [],
        "architectureKey": "talent",
        "evidence": {
            "items": [
                [
                    "岗位建模",
                    "岗位胜任力与行业建模",
                    "JD × 行业经验 × 用人标准"
                ],
                [
                    "行为证据",
                    "结构化面试方法",
                    "BEI · STAR · Topgrading"
                ],
                [
                    "职业心理",
                    "工作风格与行为维度",
                    "借鉴霍根 · 情境追问"
                ],
                [
                    "质量校准",
                    "测评标准与验收设计",
                    "引用支持 · 一致性 · 复核耗时"
                ]
            ],
            "sources": [
                0,
                1,
                2,
                3
            ],
            "emphasis": [
                "岗位胜任力",
                "BEI 行为事件访谈、STAR 原则和 Topgrading 职业经历核查思路",
                "工作风格、动机与价值观、行为风险维度",
                "共同评价维度与行为分级标准",
                "信息遗漏、引用支持度、评分一致性及人工复核耗时",
                "产品演示、现场引导和业务反馈"
            ],
            "qualitative": true
        }
    },
    {
        "title": "AI LAB 公共能力平台：Agent 工程与交付体系",
        "period": "2026.05-至今",
        "keywords": "【关键词】Agent 架构、语言工程、任务编排、偏好对齐、r0-skill、研发 SOP、公共能力平台",
        "desc": "面向多个业务 Agent 的持续研发与交付，形成并沉淀“语言工程、任务编排、偏好对齐”三大范式，据此主导公共能力与工程规范建设；按短任务、轻状态和文本密集的负载特点组织知识、工具及执行能力，为业务应用提供可复用的工程基础。",
        "points": [
            "语言工程与知识组织：将提示词、业务知识、工具描述和历史状态作为统一设计对象，定义来源、时效、权限与引用要求；从任务所需证据出发组织检索和上下文，结合本体、关系约束及知识编译方法，明确资料如何转为可追溯、可持续更新的任务上下文。",
            "任务编排与执行架构：按任务状态、依赖和风险选择循环、DAG、状态机或事件驱动方式，明确多 Agent 的职责、上下文与工具边界；主导 Noesis ADK 的 Agent 构建、上下文与验证方式并参与核心实现，区分确定性编排和业务执行，形成任务定义、上下文打包、工具接口与运行记录。",
            "偏好对齐与持续改进：围绕业务目标、质量要求和用户反馈设计评价标准与改进路径，将任务验证、人工评审和失败案例组织为可复核依据；沉淀到规则、Skill 与 AI-SOP，推动团队把反馈转为可复用的行为约束和验收要求。",
            "研发 SOP 与质量门禁：通过 r0-skill 体系（skill.shine-shy.com）制定覆盖需求澄清、系统理解、方案设计与评审、实现验证、代码审查和提交归档的研发流程，明确阶段输入输出、责任与放行条件；将共享规范、检查脚本和记录模板嵌入流程，建立阻断回流、修复复验及经验沉淀机制。",
            "共用能力与架构边界：统筹知识检索、文件资产、模型接入和业务工具建设，明确资料来源、权限、版本及各服务职责；按业务场景接入研发评审、日志排障和业务问数，兼顾平台复用与单场景的交付要求。",
            "任务隔离与可靠运行：针对并发任务资料混用、重复构建和证据漂移，完善独立任务空间、来源校验、幂等控制及可恢复归档；同步跨语言接口、诊断协议和示例，完成相应本地回归，支撑后续业务接入验证。",
            "交付与复用成果：建设涵盖 Agent 原理、语言工程、知识系统与 AI 编程实践的团队知识库，沉淀技术判断与选型依据；落地共用研发环境、项目管理中枢、新人指引及资源管理制度，落实数据发版与上线核查，统一部署、验收与回退要求，形成方法沉淀、工程复用与业务交付协同演进的工作体系。"
        ],
        "id": "platform",
        "legacyIndex": null,
        "category": "平台与研发",
        "stage": "阶段交付",
        "metric": "沉淀语言工程、任务编排、偏好对齐三大范式；交付 ADK 阶段能力、研发 SOP、共用环境与团队知识资产。",
        "labels": [],
        "architectureKey": "platform",
        "evidence": {
            "items": [
                [
                    "三大范式",
                    "Agent 工程方法",
                    "语言工程 · 任务编排 · 偏好对齐"
                ],
                [
                    "任务隔离",
                    "可靠共用能力",
                    "来源校验 · 幂等 · 恢复"
                ],
                [
                    "研发 SOP",
                    "团队交付机制",
                    "质量门禁 · 修复复验 · 经验沉淀"
                ]
            ],
            "sources": [
                0,
                5,
                3
            ],
            "emphasis": [],
            "qualitative": true
        },
        "resources": [
            {
                "label": "r0-skill · 研发流程与工具",
                "href": "https://skill.shine-shy.com/"
            }
        ]
    },
    {
        "title": "LatticeFlow 高速数仓：高性能实时数据平台",
        "period": "2026.04-至今",
        "keywords": "【关键词】Rust、高性能计算、实时数仓、流式处理、数据一致性、容量治理、业务监控",
        "desc": "面向高频业务事件和实时经营分析，主导高速数仓技术路线与核心计算能力建设，打通数据采集、实时处理和分析服务；以Rust 高性能计算算子为核心，支撑大规模数据处理与多业务场景复用。",
        "points": [
            "核心计算与性能优化：完成 Rust 核心计算算子研发并验证性能提升，优化关键计算路径与批量处理效率，提升高负载场景下的处理能力；统筹吞吐、响应速度与资源使用，形成兼顾性能、可靠性和持续扩展的计算体系。",
            "实时架构与数据一致性：建立采集、计算和结果服务的统一架构，将状态恢复、一致性控制和异常处理纳入核心流程；支持持续数据更新、历史补算与结果修正，保持正常运行和故障恢复后的指标口径一致。",
            "指标体系与业务建模：统一关键业务实体、指标口径与时间语义，处理迟到数据与历史状态修正；沉淀可复用的实时指标和分析模型，保障跨业务场景数据的一致性与可解释性。",
            "可靠性与处理能力：建立容量管理、运行观测、故障恢复和数据核验机制，覆盖实时处理、异常隔离及历史回放；已具备约 3.3 万条/秒的数据处理能力，支撑业务增长、流量波动和多场景并行接入。",
            "生产落地与业务价值：承接两类核心业务源事件约 1.78 亿条/日的数据规模（24 小时统计），完成实时主链路与多业务场景生产落地；支撑经营指标监测、关键交易链路风险预警和用户增长分析，为跨平台异常发现、原因定位与运营决策提供实时数据依据。",
            "平台复用与持续演进：将已验收的业务能力沉淀为可复用的指标、数据模型与分析服务，支撑渠道效果评估、转化优化及业务自助分析；落地分层存储与跨数据源联合分析，形成实时与历史数据协同的共用数据基础，支持新业务场景持续接入。"
        ],
        "id": "lattice",
        "legacyIndex": 3,
        "category": "数据与经营",
        "stage": "生产交付",
        "metric": "已具备约 3.3 万条/秒处理能力；承接约 1.78 亿条/日源事件；支撑经营监测、交易风险预警及用户增长分析。",
        "labels": [],
        "architectureKey": "lattice",
        "evidence": {
            "items": [
                [
                    "约 3.3 万条/秒",
                    "数据处理能力",
                    "持续处理 · 多场景接入"
                ],
                [
                    "约 1.78 亿条/日",
                    "源事件规模",
                    "两类核心业务源事件 · 24 小时统计"
                ],
                [
                    "共用平台",
                    "指标与分析服务复用",
                    "经营监测 · 风险预警 · 增长分析"
                ]
            ],
            "sources": [
                3,
                4,
                5
            ],
            "emphasis": [
                "已具备约 3.3 万条/秒的数据处理能力",
                "约 1.78 亿条/日",
                "完成实时主链路与多业务场景生产落地",
                "可复用的指标、数据模型与分析服务"
            ],
            "qualitative": false
        }
    },
    {
        "title": "BILM 高性能关系索引与持久化系统（Go）",
        "period": "2025.11-2026.02",
        "keywords": "【关键词】RoaringBitmap、WAL、Snapshot、内存数据库",
        "desc": "设计并实现基础设施级的 BILM（Bitmap-based Inverted Label Matrix）关系索引系统，面向推荐、风控、画像等大规模关联查询场景，兼顾内存查询性能与数据库级可靠性。在大数据量下完成了高性能的二元关系衍生的代数运算功能。",
        "points": [
            "采用 RoaringBitmap 构建主索引结构（smallID → largeID），通过集合包含判断完成反向查询，移除冗余 forward 索引，在不牺牲功能的前提下显著降低内存占用与快照峰值。",
            "构建 Snapshot + Delta + WAL 的多级持久化链路，引入 WAL 先写机制、CRC 校验与原子落盘策略，确保异常中断场景下的数据一致性与可恢复性，对标数据库与 Redis 的可靠性设计思路。",
            "设计基于 Dirty 集合的增量快照机制，结合阈值控制与回退策略，显著降低高频全量快照带来的 CPU / GC 与 I/O 压力，提升系统在高写入负载下的稳定性。",
            "通过锁内一致性切点 + 锁外 I/O 的快照流程优化，减少写路径阻塞时间；在 largeID 3000 万 / smallID 500 级别规模下完成验证，具备明确的成本优势与工程可扩展性。"
        ],
        "id": "bilm",
        "legacyIndex": 4,
        "category": "平台与研发",
        "stage": "实现验证",
        "metric": "在 largeID 3000 万 / smallID 500 级别规模下完成验证。",
        "labels": [],
        "architectureKey": "bilm",
        "evidence": {
            "items": [
                [
                    "3000 万",
                    "largeID 规模",
                    "关系索引验证"
                ],
                [
                    "500",
                    "smallID 规模",
                    "同一规模验证的另一维度"
                ]
            ],
            "sources": [
                3,
                3
            ],
            "emphasis": [
                "largeID 3000 万 / smallID 500 级别规模下完成验证"
            ],
            "qualitative": false
        }
    },
    {
        "title": "全球站推荐：用户节奏感知的受约束收益优化推荐系统",
        "period": "2025.09-至今",
        "keywords": "【关键词】用户分群、行为序列建模、多目标排序、风险感知推荐、生命周期约束、策略编排",
        "desc": "构建以用户行为节奏与生命周期保护为核心的推荐系统，打通用户聚合指标、Session 行为序列、状态分群与推荐闭环，在风险可控前提下实现长期收益最大化。",
        "points": [
            "规则主导的用户分群体系：基于资金、行为与状态三维特征定义核心用户标签，引入 K-Means / GMM 对规则分群进行置信度校验，提升分群稳定性与可解释性。",
            "两级用户分群与状态优先级机制：在价值分层基础上建模用户情绪与行为状态（兴奋、追损、挫败、平稳、冷却），通过状态优先级驱动推荐策略切换。",
            "多目标排序与分群感知权重机制：联合建模平台收益、状态匹配度、沉浸度与新颖度，不同用户状态下动态调整排序权重，避免单一 ROI 贪心失控。",
            "显式风险建模与硬约束控制：基于输赢节奏构建风险估计函数，并在高风险状态下执行波动率约束，实现推荐结果的工程可控与节奏保护。"
        ],
        "id": "global-recommendation",
        "legacyIndex": 5,
        "category": "数据与经营",
        "stage": "技术方案",
        "metric": "以状态分群、多目标排序和显式风险约束组织推荐策略。",
        "labels": [],
        "architectureKey": "global-recommendation",
        "evidence": {
            "items": [
                [
                    "状态感知",
                    "用户分群与策略切换",
                    "生命周期 · 价值分层"
                ],
                [
                    "多目标",
                    "排序权重与目标取舍",
                    "匹配 · 多样性 · 长期目标"
                ],
                [
                    "硬约束",
                    "风险与用户节奏保护",
                    "可控推荐输出"
                ]
            ],
            "sources": [
                1,
                2,
                3
            ],
            "emphasis": [],
            "qualitative": true
        }
    },
    {
        "title": "达人智选：多链路召回与社交协同驱动的KOL智能推荐系统",
        "period": "2024.06-2025.07",
        "keywords": "【关键词】多链路召回、双塔模型、相似度排序、圈层分发、内容聚类、Feed流、社交图、联合推荐",
        "desc": "构建基于多维相似度的达人筛选与推荐引擎，打通内容聚类、语义召回、加权排序、圈层控制与预算调度全链路，支持多维召回、圈层策略、Feed流推荐与达人社交联合推荐。",
        "points": [
            "多链路召回与六维相似度融合：构建四路语义召回并扩展为六链路体系，实现基于达人内容、画像、商单与品类的语义建模与候选生成，召回命中率≥85%，实现召回层的结构化控制与多样性提升。",
            "最大中心度贪心迁移算法：优化达人在策略圈层中的排序分布，解决均摊策略导致的错位问题，提升策略一致性与优质达人分配率。",
            "Feed流推荐系统：支持达人间“自发现”推荐，结构为强匹配、延展、潜力、破圈四层，融合推荐理由、行为反馈与滚动加载，Feed点击率提升23%。",
            "联合智选——社交图驱动的联合推荐机制：基于达人互动关系构建社交网络，设计联合推荐策略，支持满足Nice值的亲近达人组合推荐，机制已覆盖超30%推荐任务场景。",
            "策略编排与结构优化引擎：打造基于圈层结构与目标感知的推荐策略引擎，支持召回强度、筛选阈值、圈层比例、达人迁移策略的动态配置与自动执行，实现推荐策略的“结构化编排”与“分发路径优化”；结合业务目标自适应调度，实现多营销场景下的主动推荐生成与可控策略闭环。目前已接入超20个游戏项目组流程。"
        ],
        "id": "kol",
        "legacyIndex": 6,
        "category": "推荐与算法",
        "stage": "已交付",
        "metric": "召回命中率 ≥85%；Feed 点击率提升 23%；联合推荐覆盖超 30% 任务场景，接入超 20 个游戏项目组。",
        "labels": [],
        "architectureKey": "kol",
        "evidence": {
            "items": [
                [
                    "≥85%",
                    "召回命中率",
                    "多链路召回"
                ],
                [
                    "+23%",
                    "Feed 点击率",
                    "Feed 推荐效果"
                ],
                [
                    "超 30%",
                    "联合推荐覆盖",
                    "推荐任务场景"
                ],
                [
                    "超 20 个",
                    "游戏项目组接入",
                    "流程接入范围"
                ]
            ],
            "sources": [
                0,
                2,
                3,
                4
            ],
            "emphasis": [
                "召回命中率≥85%",
                "Feed点击率提升23%",
                "机制已覆盖超30%推荐任务场景",
                "已接入超20个游戏项目组流程"
            ],
            "qualitative": false
        }
    },
    {
        "title": "自动化数据分析管线",
        "period": "2023.03-2024.07",
        "keywords": "【关键词】LLM, ToolMaker, LATM, NvBench, Prompt Engineering, 数据安全",
        "desc": "构建大语言模型驱动的数据分析管线，将DA（数据分析）任务分解为数据读取、可视化生成与智能分析三阶段，支持面向自然语言的业务数据洞察、可视化与结构化分析输出。",
        "points": [
            "设计三阶段策略，引入多轮 Prompt 编排与结构化信息压缩方法，基于用户问题与数据库 schema 自动生成数据提取与处理代码。",
            "引入 LATM 框架，构建 ToolMaker / ToolUser 解耦结构。ToolMaker负责分析工具函数的自动构造与验证，ToolUser 负责函数组合与调用推理，实现通用数据分析能力的函数级封装与调度，推理成本整体下降逾 60%。",
            "构建私有化沙箱执行环境，在 code execution 阶段隔离敏感数据；洞察输出阶段引入指标扰动、数据混淆与不可逆脱敏策略，以确保业务数据在可控范围内被 LLM 消化。",
            "基于改造版 NvBench 数据集完成评估，分析能力在准确率与可读性等指标上与资深分析师持平，召回率提升 10.7%，可替代初级分析师工时超 70%。已实现多业务结构间的模板级自动适配。"
        ],
        "id": "analytics",
        "legacyIndex": 7,
        "category": "数据与经营",
        "stage": "评测验证",
        "metric": "推理成本下降逾 60%；改造版 NvBench 评估中召回率提升 10.7%，可替代初级分析师工时超 70%。",
        "labels": [],
        "architectureKey": "analytics",
        "evidence": {
            "items": [
                [
                    "逾 60%",
                    "推理成本下降",
                    "LATM 工具构造与调用复用"
                ],
                [
                    "+10.7%",
                    "召回率提升",
                    "改造版 NvBench 评估"
                ],
                [
                    "超 70%",
                    "可替代初级分析师工时",
                    "所述评估范围"
                ]
            ],
            "sources": [
                1,
                3,
                3
            ],
            "emphasis": [
                "推理成本整体下降逾 60%",
                "召回率提升 10.7%",
                "可替代初级分析师工时超 70%"
            ],
            "qualitative": false
        }
    },
    {
        "title": "星瞳 text2motion 动作生成系统",
        "period": "2023.02-2024.07",
        "keywords": "【关键词】LLM, RAG, CLIP, MotionCLIP, Fantasia3D, SAM, 动作生成管线",
        "desc": "参与“星瞳”text2motion 系统的研发，构建自然语言驱动的角色动作生成流程，打通指令理解、动作检索、姿态合成与动画渲染全链路，支撑虚拟人内容生成能力建设。",
        "points": [
            "负责 LLM 指令解析模块开发，设计多轮 Prompt 编排策略，结合数据库 schema 与语义范式，将用户自然语言指令转化为结构化动作意图，驱动下游生成链路。",
            "参与实现动作检索链路，构建基于 CLIP / MotionCLIP 的语义动作 embedding 检索机制，实现语义层级的高精度动作片段匹配与动态组合；支持多语言与同义表达泛化。",
            "参与实现动作合成与姿态修正模块，基于 Fantasia3D、DragGAN 等生成模型完成角色动画构建，引入 SAM 自动分割人体区域用于动作目标区域定位，结合 DINO 自监督特征提取模型，进行骨骼关键点检测与跟踪，对连续动作帧执行姿态稳定性分析，自动识别并过滤骨骼跳变、肢体穿插等异常状态，有效提升动作序列的连贯性与物理合理性。",
            "支持中英双语文本驱动动作生成，主流动作生成成功率≥80%。已完成3次“直播3D回”的0bug运行。"
        ],
        "id": "motion",
        "legacyIndex": 8,
        "category": "游戏与创作",
        "stage": "场景验证",
        "metric": "主流动作生成成功率 ≥80%；3 次直播 3D 回均实现 0 bug 运行。",
        "labels": [],
        "architectureKey": "motion",
        "evidence": {
            "items": [
                [
                    "≥80%",
                    "主流动作生成成功率",
                    "所述动作范围"
                ],
                [
                    "3 次",
                    "直播 3D 回运行",
                    "3 次直播验证"
                ]
            ],
            "sources": [
                3,
                3
            ],
            "emphasis": [
                "主流动作生成成功率≥80%",
                "已完成3次“直播3D回”的0bug运行"
            ],
            "qualitative": false
        }
    },
    {
        "title": "基于强化学习的碳中和政策模拟系统",
        "period": "2022.02-2022.06",
        "keywords": "【关键词】强化学习、因果推断、政策优化、奖励函数设计、因果图",
        "desc": "参与碳中和战略相关的政策模拟项目，基于历史能耗与排放数据，优化政府与企业的长期政策路径（如碳税、电价调控、科研资源分配）。",
        "points": [
            "独立设计马尔可夫决策过程（MDP）中的状态空间与动作空间，并且针对政策干预的延迟反馈特性，自主构造 reward shaping 策略：引入时间折现、分段阈值惩罚与社会成本加权，引导策略在碳排放下降与经济可持续间权衡，有效提升策略稳定性并避免短期激进解。",
            "搭建多策略对比实验框架，基于 DQN 与 PPO 在不同假设场景中完成策略训练与回放，最优策略在模拟环境下实现碳排放下降 18%、社会成本降低 12%。融合因果图建模与 do-calculus 推理，提升对策略行为背后变量因果关系的解释能力，策略波动性减少 21%。在此基础上完成可解释性因果输出，增强模型在跨部门最终研讨中的政策可接受性（7/8）。"
        ],
        "id": "carbon",
        "legacyIndex": 9,
        "category": "推荐与算法",
        "stage": "模拟研究",
        "metric": "模拟环境最优策略：碳排放下降 18%、社会成本降低 12%、策略波动性减少 21%；研讨接受度 7/8。",
        "labels": [],
        "architectureKey": "carbon",
        "evidence": {
            "items": [
                [
                    "−18%",
                    "碳排放",
                    "模拟环境最优策略"
                ],
                [
                    "−12%",
                    "社会成本",
                    "模拟环境最优策略"
                ],
                [
                    "−21%",
                    "策略波动性",
                    "模拟环境研究结果"
                ]
            ],
            "sources": [
                1,
                1,
                1
            ],
            "emphasis": [
                "模拟环境下实现碳排放下降 18%、社会成本降低 12%",
                "策略波动性减少 21%"
            ],
            "qualitative": false,
            "scope": "策略模拟实验与跨部门研讨"
        }
    },
    {
        "id": "locate",
        "title": "Locate：多语言本地化工作台",
        "category": "内容与本地化",
        "stage": "初版交付 · 业务试用",
        "desc": "统筹多语言本地化产品，将表格翻译、术语复用、格式约束与质量核对组织为批量工作流。",
        "points": [
            "输入与任务组织：支持 xlsx、多子表及自然语言列配置，按目标语言与术语风格预设组织翻译任务。",
            "一致性控制：管理保留词、数字、变量、指定词表与同表术语复用，将译文内容与格式检查分别处理。",
            "交付与验证：已完成初版部署、供应商翻译对比及多轮边界修复，推进真实业务试用与回归。多子表、编码与语言脚本边界继续按实际输入核对。"
        ],
        "metric": "初版本地化工作台已交付并进入业务试用，结合自动校验与人工审阅核对翻译质量。",
        "labels": [],
        "keywords": "",
        "period": "2026.06 起",
        "architectureKey": "locate"
    },
    {
        "id": "aletheia",
        "title": "Aletheia 智脑：分层知识与证据原型",
        "category": "知识与组织",
        "stage": "原型验证",
        "desc": "围绕团队资料的真源、知识加工和任务上下文，推进早期分层知识系统原型。",
        "points": [
            "系统结构：Lark 真源经 L0/L1/L2/L3 分层处理，由 Rust API、Agent/MCP 与 Web 提供访问，包含查询改写和评测种子。",
            "原型进展：完成知识分层与访问流程，后续完善服务接入、权限及同步机制。"
        ],
        "metric": "已形成知识分层、检索与服务访问原型。",
        "labels": [],
        "keywords": "",
        "period": "2026.06 起",
        "architectureKey": "aletheia"
    },
    {
        "id": "piggy",
        "title": "Piggy Tap：游戏运行与 Creator 重构",
        "category": "游戏与创作",
        "stage": "迭代验证",
        "desc": "组织游戏表现、状态恢复与后端结果一致性核对；该项目后续并入游戏自动化工具。",
        "points": [
            "运行链路：接入既有结果库，核对历史结果恢复、运行态显示、结算和视觉规则的一致性。",
            "运行验证：完成服务与数据库结果对账，持续推进正式入口、特殊玩法及异常分支验收。"
        ],
        "metric": "阶段运行链路已验证，整体验收仍在推进。",
        "labels": [],
        "keywords": "",
        "period": "2026.06 起",
        "architectureKey": "piggy"
    },
    {
        "id": "aviator",
        "title": "Aviator：子游戏研发协助",
        "category": "游戏与创作",
        "stage": "方案与实现协作",
        "desc": "组织前后端职责拆分、规则口径及接口验收定义，后续并入子游戏研发协助。",
        "points": [
            "推进重点：前端表现与服务端规则分别管理，优先厘清规则边界、配置口径和测试标准。",
            "阶段进展：前端复刻暂缓，后端算法与接口协作持续推进。"
        ],
        "metric": "完成研发任务拆分、规则定义与接口验收方案。",
        "labels": [],
        "keywords": "",
        "period": "2026.07 起"
    },
    {
        "id": "adk",
        "title": "Noesis ADK：Agent 开发框架",
        "category": "平台与研发",
        "stage": "阶段实现",
        "desc": "主导 Agent 构建、上下文组织与验证方式，参与核心实现，以确定性编排承载业务执行。",
        "points": [
            "任务定义：通过任务清单明确输入、必需证据组、工具与执行范围，区分上下文构建和业务执行。",
            "上下文工程：为每个任务建立独立空间，导入不可变资料，校验来源摘要与必需证据，生成可追溯 ContextPack。",
            "可靠运行：以并发锁、幂等复用和可恢复归档控制串包、重复构建与证据漂移；同步 CLI、MCP 与跨语言契约。",
            "阶段验证：已完成阶段开发与本地回归，业务 Agent 迁入和生产验收按场景推进。"
        ],
        "metric": "任务隔离、证据校验、幂等复用与归档恢复形成阶段实现。",
        "labels": [],
        "keywords": "",
        "period": "2026.06 起",
        "architectureKey": "adk"
    },
    {
        "id": "gateway",
        "title": "Noesis API：企业模型访问网关",
        "category": "平台与研发",
        "stage": "生产部署",
        "desc": "统筹模型访问入口、资源治理和发布运维，为业务工具提供共用模型服务。",
        "points": [
            "访问与路由：管理 API Key、账号路由和模型访问，将上游能力与业务接入分层。",
            "资源治理：覆盖用量、成本、首 token 时间等观测，推进账号状态与请求失败诊断。",
            "交付与演进：生产网关已有部署记录；后续生图客户端配置适配已部署，实际客户端出图按场景继续验收。"
        ],
        "metric": "共用生产网关已提供模型访问及资源管理能力。",
        "labels": [],
        "keywords": "",
        "period": "2026.05 起",
        "architectureKey": "gateway"
    },
    {
        "id": "screen",
        "title": "Noesis Screen：AI LAB 展示大屏",
        "category": "平台与研发",
        "stage": "展示版本评审",
        "desc": "组织团队工作入口与成果展示，建设轻量静态站点。",
        "points": [
            "实现范围：静态 HTML、本地素材和前端依赖形成展示页面。",
            "验证范围：资源完整性、访问路径与视觉表现；当前为静态初版。"
        ],
        "metric": "静态展示版本已形成，部署验收待完成。",
        "labels": [],
        "keywords": "",
        "period": "2026.05 起",
        "architectureKey": "screen"
    },
    {
        "id": "seven",
        "title": "7up7down：规则建模与数值验证",
        "category": "游戏与创作",
        "stage": "调研完成",
        "desc": "组织游戏规则、数值配置与实现验收之间的口径对齐，后续并入子游戏研发协助。",
        "points": [
            "交付内容：完成数值文档和规则边界整理，明确概率、奖励、配置与库存的一致性要求。",
            "后续衔接：推进配置表、服务端实现和测试用例，衔接线上产品验收。"
        ],
        "metric": "规则调研与数值文档已完成。",
        "labels": [],
        "keywords": "",
        "period": "2026.07 起"
    },
    {
        "id": "logs",
        "title": "智慧日志：异常研判与研发排障",
        "category": "线上运营",
        "stage": "生产部署 · 小范围使用",
        "desc": "推动日志诊断 Agent 嵌入业务集群，将错误日志、参考文档和排查建议连接为可追溯的线上研判流程。",
        "points": [
            "当前架构：业务侧定时触发 Agent，直连本集群 ClickHouse 采集 Error 日志，结合参考文档完成研判，由 Lark Bot 推送错误、可能影响和排查建议。",
            "部署边界：每个业务组部署独立实例，日志和权限留在各自集群；现有 ClickVisual 基础告警保持独立。",
            "结果控制：未采集到错误时不研判、不通知；研判失败时不发送不完整结论。Agent 提供分析与建议，生产处置仍由人员负责。",
            "阶段与演进：已有生产部署和线上告警反馈；trace 聚合、运营报告、负责人映射及更大范围推广为后续改进，自定义策略与自动 SQL 仍属设计方向。"
        ],
        "metric": "完成生产部署并投入小范围使用，支持线上告警研判与研发排障。",
        "labels": [],
        "keywords": "",
        "period": "2026.07 起",
        "architectureKey": "logs"
    },
    {
        "id": "pr-review",
        "title": "PR Agent：跨仓库代码影响审查",
        "category": "平台与研发",
        "stage": "试点与设计验证",
        "desc": "牵头研发审查场景收敛，优先复用单仓库审查内核，将投入集中于跨仓服务关系、变更影响和交付证据。",
        "points": [
            "控制面：由发布模板确认审查范围，冻结 MR Head、Base、Diff、CI 与规则版本，形成不可变审核会话。",
            "分层执行：PR-Agent 内核处理单 MR；Orchestrator 负责多 MR 编排、关系证据、状态与结果聚合；受限 Runner 仅执行授权检查。",
            "关系分析：通过接口契约、调用点、构建依赖和消息资源建立证据关系，区分已确认、待确认和范围外未知。",
            "审查报告与试点：形成跨仓审查方案与审核样本，报告关联代码定位、版本、失败项及待验证问题，合并与发布由研发团队审批。"
        ],
        "metric": "形成跨仓审查方案与验证样本；实际仓库接入按授权范围推进。",
        "labels": [],
        "keywords": "",
        "period": "",
        "architectureKey": "pr-review"
    },
    {
        "id": "individual",
        "title": "超级个体：工作流研究与维护",
        "category": "平台与研发",
        "stage": "探索中",
        "desc": "探索个人工作流的组织方式，推进超级个体雏形构建与维护。",
        "points": [
            "研究方向：超级个体雏形构建与工作流维护。"
        ],
        "metric": "",
        "labels": [],
        "keywords": "",
        "period": ""
    },
    {
        "id": "payment-alerts",
        "title": "联运推送：支付成功率与异常通知",
        "category": "线上运营",
        "stage": "已交付",
        "desc": "统筹数据团队交付商户代收、代付与异常通知，统一指标口径和消息模板。",
        "points": [
            "数据组织：分别聚合商户代收与代付成功率，按业务平台和统计窗口组织监控数据。",
            "业务交付：交付近 10 分钟充值、支付成功率预警及近 1 小时提现失败原因推送。",
            "统计设计：采用 10 分钟与 1 小时窗口，基于 Lattice 实时数据能力组织监控与通知；统计窗口与处理时延分别衡量。"
        ],
        "metric": "成功率与异常通知已完成业务交付。",
        "labels": [],
        "keywords": "",
        "period": "2026.08 起",
        "architectureKey": "payment-alerts"
    },
    {
        "id": "withdrawal",
        "title": "提现失败原因监控",
        "category": "线上运营",
        "stage": "已交付",
        "desc": "组织支付异常的归因统计与业务触达，支撑运营定位商户和通道异常。",
        "points": [
            "处理范围：汇总近 1 小时提现失败原因，以业务需要的模板输出。",
            "业务交付：覆盖 3 个业务平台，核对数据口径和通知内容，复用实时数据平台能力。"
        ],
        "metric": "3 个平台的近 1 小时提现失败原因监控已交付。",
        "labels": [],
        "keywords": "",
        "period": "2026.08 起",
        "architectureKey": "withdrawal"
    },
    {
        "id": "acquisition",
        "title": "获客转化监控：W2A 与自裂变",
        "category": "线上运营",
        "stage": "业务验收",
        "desc": "组织用户增长场景的数据监控，连接获客事件、转化口径和异常识别。",
        "points": [
            "业务建模：围绕浏览、点击、注册等获客漏斗组织统计与窗口分析，统一业务口径。",
            "交付结果：交付双类获客场景的转化监控，完成需求方验收，支持渠道效果分析与运营优化。",
            "统计设计：基于 Lattice 构建 10 分钟窗口的获客转化监控。"
        ],
        "metric": "获客转化监控已完成业务验收。",
        "labels": [],
        "keywords": "",
        "period": "2026.08 起",
        "architectureKey": "acquisition"
    },
    {
        "id": "ad-cost",
        "title": "投放成本上报优化",
        "category": "数据与经营",
        "stage": "已交付",
        "desc": "组织数据团队完善投放成本上报，以完整的数据输入支撑经营分析。",
        "points": [
            "交付范围：对应 FB 成本上报优化，重点核对上报完整性与业务使用口径。"
        ],
        "metric": "成本上报优化已完成。",
        "labels": [],
        "keywords": "",
        "period": "2026.08 起"
    },
    {
        "id": "vip-rewards",
        "title": "VIP 奖励规则与彩金变更",
        "category": "数据与经营",
        "stage": "已交付",
        "desc": "组织会员奖励数据变更，确保新规则与实际发奖一致。",
        "points": [
            "职责与边界：由数据团队实现规则适配，本人统筹需求、风险与交付。",
            "验收要求：按业务新规则核对奖励计算和发放，避免数据口径与运营规则脱节。"
        ],
        "metric": "会员奖励变更已完成，按新规则核对发奖结果。",
        "labels": [],
        "keywords": "",
        "period": ""
    },
    {
        "id": "subgames",
        "title": "子游戏研发协助：规则、配置与验证",
        "category": "游戏与创作",
        "stage": "离线验证与研发协作",
        "desc": "统筹子游戏研发、数值和测试协作，将规则定义、配置、实现与验证结果保持一致。",
        "points": [
            "项目范围：覆盖 Aviator、7up7down、Chicken Road 与 Money Coming 等子项目的需求分析和规则核对。",
            "技术交付：组织测试覆盖评审、配置与模型修正、不同场景模拟，梳理数值控制流程。",
            "阶段验证：已开展离线模拟，线上与业务验收按各子项目分别推进。"
        ],
        "metric": "形成规则文档、配置方案与离线验证记录。",
        "labels": [],
        "keywords": "",
        "period": "",
        "architectureKey": "subgames"
    },
    {
        "id": "game-tools",
        "title": "游戏自动化工具与开发助手",
        "category": "游戏与创作",
        "stage": "阶段验证",
        "desc": "组织游戏运行验证与开发协作工具，连接真实服务、结果核对及工作记录。",
        "points": [
            "游戏工作流：推进 Piggy Tap 的 Creator 重构、结果库接入、状态恢复和服务数据库对账。",
            "开发协作：维护日报、周报与项目关联，完善消息到开发助手的回复链路和汇报同步。",
            "验证边界：已有部分真实服务与数据链路验收；特殊玩法、正式入口和异常分支仍按任务继续验证。"
        ],
        "metric": "游戏运行和开发助手链路形成阶段成果。",
        "labels": [],
        "keywords": "",
        "period": "",
        "architectureKey": "game-tools"
    },
    {
        "id": "openclaw",
        "title": "OpenClaw：Agent 平台探索",
        "category": "平台与研发",
        "stage": "探索中",
        "desc": "探索 Agent 平台的应用方向。",
        "points": [],
        "metric": "",
        "labels": [],
        "keywords": "",
        "period": ""
    },
    {
        "id": "historical-data",
        "title": "业务标识与历史数据回填",
        "category": "数据与经营",
        "stage": "开发与验证",
        "desc": "组织历史数据回填方案收敛，按规模与后端接口变化调整实现范围。",
        "points": [
            "范围取舍：根据计算量与数据规模，将历史入库范围收敛到平台标识和 IP 信息，移除缺乏必要性的衍生统计。",
            "交付过程：同步后端接口变化并核对脚本结果，完成开发与验证，继续跟进上线验收。"
        ],
        "metric": "完成范围收敛、脚本调整与结果验证。",
        "labels": [],
        "keywords": "",
        "period": "2026.08 起"
    },
    {
        "id": "query-playbook",
        "title": "数数查数经验：业务知识沉淀",
        "category": "知识与组织",
        "stage": "文档交付",
        "desc": "组织数据查询经验沉淀，把分散的业务讨论、工具文档与历史代码形成可复用资料。",
        "points": [
            "输入来源：汇集相关聊天、平台文档与既有代码项目，整理业务使用经验。",
            "交付成果：形成查询经验文档，支撑数据协作与智能问数建设。"
        ],
        "metric": "查询经验文档已完成。",
        "labels": [],
        "keywords": "",
        "period": "2026.08 起"
    },
    {
        "id": "vip-platform",
        "title": "会员体系数据服务",
        "category": "数据与经营",
        "stage": "上线交付",
        "desc": "组织会员体系的数据服务、冷启动及跨团队接口联调，支撑业务上线。",
        "points": [
            "交付过程：同步接口变更，使用真实业务数据进行验证，定位并修复冷启动脚本问题。",
            "验证结果：完成预发布与上线核对。"
        ],
        "metric": "完成会员体系数据服务预发布与上线核对。",
        "labels": [],
        "keywords": "",
        "period": "2026.08 起",
        "architectureKey": "vip-platform"
    },
    {
        "id": "risk-data",
        "title": "风控数据：需求理解与架构方案",
        "category": "数据与经营",
        "stage": "方案设计",
        "desc": "组织风控数据需求理解与架构优化，明确业务输入和系统边界。",
        "points": [
            "当前范围：业务需求梳理、架构升级方案及数据协作。"
        ],
        "metric": "",
        "labels": [],
        "keywords": "",
        "period": "2026.08 起"
    },
    {
        "id": "logs-mcp",
        "title": "Noesis Logs MCP：受控日志工具服务",
        "category": "线上运营",
        "stage": "部署与接入验证",
        "desc": "组织日志能力服务化，使 Coding Agent 能在授权范围内把代码与日志证据关联起来。",
        "points": [
            "工具接入：通过 Streamable HTTP 暴露数据源发现和只读日志查询，以 API Key 控制访问范围。",
            "查询边界：按服务、时间和 trace/request 标识收敛查询；响应行数限制与数据库扫描成本控制分别负责，不能互相替代。",
            "使用方式：开发者选择代码与问题，Agent 查询相关日志、关联调用路径，区分观察事实与原因推断，输出排障建议。",
            "部署与接入：形成工具服务部署和客户端接入流程，按环境验证鉴权兼容、密钥轮换与查询配额。"
        ],
        "metric": "形成受控日志工具服务与 Coding Agent 接入流程。",
        "labels": [],
        "keywords": "",
        "period": "",
        "architectureKey": "logs-mcp"
    },
    {
        "id": "cashback",
        "title": "Cashback：首充礼包奖励计算",
        "category": "数据与经营",
        "stage": "测试与交付",
        "desc": "组织首充礼包事件接入奖励计算，确保业务变更后的金额正确性。",
        "points": [
            "实现范围：将新增礼包事件纳入既有会员奖励计算，检查各业务项目事件字段的一致性。",
            "阶段验证：已完成测试与预发布，继续推进线上验收。"
        ],
        "metric": "首充礼包奖励计算完成测试和阶段交付。",
        "labels": [],
        "keywords": "",
        "period": "2026.09 起"
    },
    {
        "id": "data-compression",
        "title": "日度数据压缩：可行性与风险评估",
        "category": "数据与经营",
        "stage": "方案完成",
        "desc": "组织数据压缩上报的可行性评估，在成本、计算负载与业务口径之间做方案取舍。",
        "points": [
            "评估范围：完成事件范围评估、风险分析和基础技术方案，与运营核对压缩后的数据口径。",
            "方案评审：分别评估大规模计算负载、粒度变化与分析需求，当前处于可行性评估阶段。"
        ],
        "metric": "事件评估、风险分析与基础技术方案已完成。",
        "labels": [],
        "keywords": "",
        "period": "2026.09 起"
    },
    {
        "id": "vip-evolution",
        "title": "VIP 体系迭代：历史权益数据核对",
        "category": "数据与经营",
        "stage": "研发中",
        "desc": "组织会员权益数据补齐与历史统计，保证迭代中的数据完备性。",
        "points": [
            "需求范围：统计历史免费提现节约的手续费与次数，核对权益事件字段和历史数据来源。",
            "阶段状态：技术方案已确认并进入开发，缺失字段已有解决方向，业务验收待完成。"
        ],
        "metric": "方案确认，开发与历史数据核对推进中。",
        "labels": [],
        "keywords": "",
        "period": "2026.09 起"
    },
    {
        "id": "qa",
        "title": "QA 解放计划：需求到测试证据",
        "category": "平台与研发",
        "stage": "本地初版验证",
        "desc": "牵头测试设计试点，将需求、用例、人工评审和执行回执组织为可追溯流程。",
        "points": [
            "需求与用例：保留需求快照，将显式验收表转成结构化用例；模型仅用于可选草稿生成，来源、ID 与 schema 分别校验。",
            "人工评审：用例和操作映射绑定当前输入版本，修改后撤销旧批准，避免拿历史结论覆盖新版本。",
            "执行与回执：导出独立 Playwright 执行包，运行快照绑定来源、用例、映射、环境及执行器；导入回执核对证据，失败和取消保留真实状态。",
            "原型验证：完成本地初版及隔离测试环境中的流程验证，后续推进真实业务用例与模型生成质量评估。"
        ],
        "metric": "需求、用例、评审、执行与回执形成可运行本地链路。",
        "labels": [],
        "keywords": "",
        "period": "",
        "architectureKey": "qa"
    },
    {
        "id": "figma",
        "title": "Figma 文案：语境匹配与人工审阅",
        "category": "内容与本地化",
        "stage": "本地初版验证",
        "desc": "组织设计文案提取与语言表核对，保留来源和语境，支撑多语言内容一致性。",
        "points": [
            "输入与提取：插件分批读取页面或选区 TEXT 节点，导出节点 JSON；工作台与语言表 CSV 进行严格匹配。",
            "语境与冲突：联合 key、语言、原文和语境判断候选，区分新增、复用、更新和待确认，检测目标 key 冲突。",
            "人工闭环：审阅决定绑定输入及规则版本，历史追加保留；全部未决项处理后才生成最终表，支持保存和恢复。",
            "原型验证：完成网页流程与模拟插件接口验证，后续推进 Figma 宿主、设计稿和语言表联调。"
        ],
        "metric": "严格匹配、人工审阅和最终导出已实现。",
        "labels": [],
        "keywords": "",
        "period": "",
        "architectureKey": "figma"
    },
    {
        "id": "prd",
        "title": "PRD 与原型工作台：需求映射与交互验证",
        "category": "游戏与创作",
        "stage": "本地初版验证",
        "desc": "组织需求表达、PRD 与交互原型验证，使方案展示能够回到明确的需求依据。",
        "points": [
            "原文映射：保存原始需求、段落定位和逐字引文；模型整理结果先核对出处，再由人员确认业务含义。",
            "生成与版本：将显式需求映射到受控页面模板，同步输出 PRD、单文件交互原型和对应表；输入变化后旧确认失效。",
            "交互范围：支持列表、看板、表单、空态及详情等通用交互，预览与源工作台隔离。",
            "原型验证：完成本地需求映射、模板交互和版本追踪验证，后续推进模型输出评估与业务流程联调。"
        ],
        "metric": "原文、需求、PRD、页面与版本差异形成可追踪的本地工作流。",
        "labels": [],
        "keywords": "",
        "period": "",
        "architectureKey": "prd"
    },
    {
        "id": "cover",
        "title": "游戏素材与风格工作台",
        "category": "游戏与创作",
        "stage": "本地初版验证",
        "desc": "组织游戏素材收集、来源核对和美术风格分析，支持创作准备与风格规范验证。",
        "points": [
            "素材接入：从明确来源的厂商目录与页面采集素材，核对游戏身份，保留来源、包成员和内容哈希。",
            "批量与恢复：按批次串行处理，任务状态落盘，支持中断续跑和失败重试；下载和解包设明确资源边界。",
            "美术组织：为选定游戏与目标参考图建立分析卡、风格卡及草稿版本，区分事实、图片观察和设计建议，保留人工核对。",
            "原型验证：形成素材台账、设计草稿与可导入工作包，后续推进模型输出评估及业务美术审阅。"
        ],
        "metric": "素材来源、分析卡、风格卡与版本库已形成可运行初版。",
        "labels": [],
        "keywords": "",
        "period": "",
        "architectureKey": "cover"
    },
    {
        "id": "project-knowledge",
        "title": "项目知识管理与“敞亮人”新人赋能",
        "category": "知识与组织",
        "stage": "应用验证",
        "desc": "推动项目知识管理验证与新人赋能，将团队制度、项目资料和企业知识服务用于日常协作。",
        "points": [
            "团队建设：建设新人指引、技术知识与项目管理入口，明确资料使用和协作方式。",
            "知识应用：企业知识库支撑规范查询和新人问答；独立的项目知识管理场景按验证范围推进。"
        ],
        "metric": "形成新人指引、知识服务与项目知识应用验证。",
        "labels": [],
        "keywords": "",
        "period": ""
    },
    {
        "id": "kol-feed",
        "title": "达人 Feed 流推荐",
        "category": "推荐与算法",
        "stage": "早期研发经历",
        "desc": "支持达人自发现的分层 Feed 推荐，融合推荐理由、行为反馈和滚动加载。",
        "points": [
            "纳入达人智选推荐链路，支持分层 Feed 推荐；Feed 点击率提升 23%。"
        ],
        "metric": "纳入达人智选推荐链路，支持分层 Feed 推荐；Feed 点击率提升 23%。",
        "labels": [],
        "keywords": "",
        "period": "",
        "architectureKey": null
    },
    {
        "id": "content-cluster",
        "title": "内容风格聚类",
        "category": "推荐与算法",
        "stage": "早期研发经历",
        "desc": "开展内容风格聚类研发，支撑内容理解和推荐场景。",
        "points": [],
        "metric": "",
        "labels": [],
        "keywords": "",
        "period": ""
    },
    {
        "id": "content-risk",
        "title": "内容风险识别与审查",
        "category": "推荐与算法",
        "stage": "早期研发经历",
        "desc": "开展内容风险识别与审查系统研发。",
        "points": [],
        "metric": "",
        "labels": [],
        "keywords": "",
        "period": ""
    },
    {
        "id": "grid-ocr",
        "title": "基于相对定位的网格 OCR",
        "category": "推荐与算法",
        "stage": "早期研发经历",
        "desc": "研发基于相对定位的网格 OCR 识别算法。",
        "points": [],
        "metric": "",
        "labels": [],
        "keywords": "",
        "period": ""
    },
    {
        "id": "revenue-model",
        "title": "二游营收能力评估模型",
        "category": "推荐与算法",
        "stage": "早期研发经历",
        "desc": "开展二游营收能力评估模型研发。",
        "points": [],
        "metric": "",
        "labels": [],
        "keywords": "",
        "period": ""
    },
    {
        "id": "social-mining",
        "title": "社交网络多层评分挖掘",
        "category": "推荐与算法",
        "stage": "早期研发经历",
        "desc": "研发社交网络驱动的多层评分挖掘策略。",
        "points": [],
        "metric": "",
        "labels": [],
        "keywords": "",
        "period": ""
    },
    {
        "id": "delay-queue",
        "title": "延迟队列系统",
        "category": "平台与研发",
        "stage": "早期研发经历",
        "desc": "完成团队内延迟队列系统相关研发。",
        "points": [],
        "metric": "",
        "labels": [],
        "keywords": "",
        "period": ""
    },
    {
        "id": "lora-render",
        "title": "星瞳 LoRA 与案例渲染管线",
        "category": "游戏与创作",
        "stage": "早期研发经历",
        "desc": "参与星瞳 LoRA 训练与学车案例渲染管线探索。",
        "points": [],
        "metric": "",
        "labels": [],
        "keywords": "",
        "period": ""
    },
    {
        "id": "sam-label",
        "title": "“金手指”：交互式智能图像标注",
        "category": "游戏与创作",
        "stage": "早期研发经历",
        "desc": "参与基于 SAM 的图像标注工具研发，相关发明专利申请已公开。",
        "points": [
            "相关发明专利申请已公开。"
        ],
        "metric": "相关发明专利申请已公开。",
        "labels": [],
        "keywords": "",
        "period": ""
    },
    {
        "id": "customer-service",
        "title": "智能客服探索",
        "category": "知识与组织",
        "stage": "早期研发经历",
        "desc": "参与 AIGC 中台的智能客服业务探索。",
        "points": [],
        "metric": "",
        "labels": [],
        "keywords": "",
        "period": ""
    },
    {
        "id": "clip-video",
        "title": "基于 CLIP 的视频检索",
        "category": "游戏与创作",
        "stage": "早期研发经历",
        "desc": "参与基于 CLIP 的视频检索系统探索。",
        "points": [],
        "metric": "",
        "labels": [],
        "keywords": "",
        "period": ""
    },
    {
        "id": "datagather",
        "title": "Text2SQL 微调与 DataGather",
        "category": "数据与经营",
        "stage": "早期研发经历",
        "desc": "参与 Text2SQL 模型微调，后成为部门 DataGather 工具基座。",
        "points": [],
        "metric": "",
        "labels": [],
        "keywords": "",
        "period": ""
    },
    {
        "id": "youkeai",
        "title": "游可爱：多端 KOL 激励平台",
        "category": "平台与研发",
        "stage": "早期研发经历",
        "desc": "负责游可爱后端开发，建设涵盖 KOL、内容、MCN 和激励任务的多端平台。",
        "points": [
            "覆盖任务维度、内容维度的流程管理及多角色权限。"
        ],
        "metric": "覆盖任务维度、内容维度的流程管理及多角色权限。",
        "labels": [],
        "keywords": "",
        "period": "",
        "architectureKey": "youkeai"
    },
    {
        "id": "driving",
        "title": "自动驾驶行为与路径规划",
        "category": "推荐与算法",
        "stage": "早期研发经历",
        "desc": "参与行为规划与路径规划模块，落地无保护左转、交叉路口、环岛与车道变换等场景逻辑。",
        "points": [
            "参与行为与路径规划模块，结合 HD 地图、感知数据、规则状态机与候选轨迹评估实现场景决策。"
        ],
        "metric": "参与行为与路径规划模块，结合 HD 地图、感知数据、规则状态机与候选轨迹评估实现场景决策。",
        "labels": [],
        "keywords": "",
        "period": "",
        "architectureKey": "driving"
    }
];
